export default {
  "session.securityLogout": "",
  "session.differentNewPassword": "",
  "session.differentPassword": "",
  "session.authorizationError": "",
  "messages.error": "",
  "messages.serverError": "",
  "messages.notFound": "",
  "messages.yes": "",
  "messages.no": "",
  "messages.back": "",
  "messages.close": "",
  "messages.filtering": "",
  "messages.clearForm": "",
  "messages.list": "{header}",
  "messages.successSave": "",
  "messages.processingError": "",
  "messages.error500": "",
  "messages.retryLoading": "",
  "messages.print": "",
  "messages.printOffer": "",
  "messages.delete": "",
  "messages.here": "",
  "messages.save": "",
  "messages.insert": "",
  "messages.cancel": "",
  "messages.showAll": "",
  "messages.hideAll": "",
  "messages.continue": "",
  "messages.calculate": "",
  "messages.warning": "",
  "messages.confirm": "",
  "messages.formLoadError": "",
  "messages.logOut": "",
  "messages.loggedOut": "",
  "messages.chooseDate": "",
  "messages.validEmail": "",
  "messages.validVariableSymbol": "",
  "messages.validUnCode": "",
  "messages.range": "{min}{max}",
  "messages.lastWeek": "",
  "messages.lastMonth": "",
  "messages.loading": "",
  "messages.loadAgain": "",
  "messages.loadError": "",
  "messages.loadErrorEntity": "{what}",
  "messages.errorTitle": "",
  "messages.unknownError": "",
  "messages.saveFail": "",
  "messages.saveFailBut": "{item}",
  "messages.deselectAll": "",
  "messages.selectAll": "",
  "messages.allCorect": "",
  "messages.someIncorrect": "",
  "messages.filter": "",
  "messages.editItem": "",
  "messages.dropItem": "",
  "messages.drop.question": "",
  "messages.noRoles": "",
  "messages.noRoles.info": "",
  "messages.connection.error": "",
  "messages.validAccount": "",
  "messages.search": "",
  "messages.input.required": "",
  "messages.maxLength": "",
  clientUser: "",
  "clientUser.info": "",
  "clientUser.user": "",
  "clientUser.client": "",
  "clientUser.accountOrName": "",
  "clientUser.username": "",
  "clientUser.client.name": "",
  "clientUser.client.companyId": "",
  "clientUser.client.account": "",
  "clientUser.client.evoCode": "",
  "crud.edit": "{what}",
  "crud.editError": "{whatError}",
  "crud.delete": "{what}.",
  "crud.deleteError": "{whatError}!",
  "footer.fraud": "",
  "footer.terms": "",
  "footer.legal": "",
  "footer.privacy": "",
  "footer.conflict": "",
  "footer.access": "",
  "footer.follow": "",
  "footer.version": "{version}",
  "footer.rights": "{year}",
  "header.home": "",
  "header.contact": "",
  "header.news": "",
  "header.services": "",
  "header.backToMain": "",
  "menu.newConsignment": "",
  "menu.newConsignment.new": "",
  "menu.newConsignment.import": "",
  "menu.newConsignment.template": "",
  "menu.consignmentList": "",
  "menu.consignmentList.notSent": "",
  "menu.consignmentList.sent": "",
  "menu.tracking": "",
  "menu.customers": "",
  "menu.calculator": "",
  "menu.contracts": "",
  "menu.invoices": "",
  "menu.setting": "",
  "menu.setting.users": "",
  "menu.setting.oneTimeLogin": "",
  "menu.setting.changePassword": "",
  "menu.notifications": "",
  "menu.documents": "",
  "menu.documents.new": "",
  language: "",
  "language.errorName": "",
  user: "",
  "user.whom": "",
  "user.list": "",
  "user.new": "",
  "user.edit": "",
  "user.add": "",
  "user.add.title": "",
  "user.add.info": "",
  "user.changePassword": "",
  "user.currentPassword": "",
  "user.newPassword": "",
  "user.confirmNewPassword": "",
  "user.emptyCurrentPassword": "",
  "user.emptyNewPassword": "",
  "user.emptyConfirmNewPassword": "",
  "user.savePassword": "",
  "user.resetPassword": "",
  "user.resetingPassword": "",
  "user.signOutByPassword": "",
  "user.yourPassword": "",
  "user.usersPassword": "{username}",
  "user.passwordQuestion": "{username}{email}",
  "user.sendToMail": "",
  "user.showHere": "",
  "user.createNew": "",
  "user.save": "",
  "user.saved": "",
  "user.saveError": "",
  "user.usedUsername": "",
  "user.freeUsername": "",
  "user.errorName": "",
  "user.expiredPassword": "",
  "user.successfulLogin": "",
  "user.serverError": "",
  "user.emptyFirstName": "",
  "user.emptyLastName": "",
  "user.emptyEmail": "",
  "user.emptyUserName": "",
  "user.firstname": "",
  "user.lastname": "",
  "user.username": "",
  "user.userrole": "",
  "user.note": "",
  "user.email": "",
  "user.admin": "",
  "user.admin.yes": "",
  "user.admin.no": "",
  "user.blocked": "",
  "user.lastLogin": "",
  "user.passwordChange": "",
  "user.passwordValidity": "",
  "user.generatingPassword": "",
  "user.noUsers": "",
  "user.activedAccount": "{suffix}",
  "user.blockedAccount": "{suffix}",
  "user.enableAccount": "",
  "user.disableAccount": "",
  "user.signIn.message": "",
  "user.signIn.contact": "",
  "user.signIn.username": "",
  "user.signIn.password": "",
  "user.signIn.emptyUserName": "",
  "user.signIn.emptyPassword": "",
  "user.signIn.signIn": "",
  "user.register": "",
  "user.register.title": "",
  "user.client.choose": "",
  "user.client.loadError": "",
  "user.client.info": "",
  "user.company": "",
  "user.noClients": "",
  "user.menu": "",
  "user.cs": "",
  customer: "",
  "customer.genitiv": "",
  "customer.genitivMultiple": "",
  "customer.multiple": "",
  "customer.errorName": "",
  "customer.edit": "",
  "customer.edit.try": "",
  "customer.import": "",
  "customer.export": "",
  "customer.exportWhom": "",
  "customer.list": "",
  "customer.add": "",
  "customer.save": "",
  "customer.new": "",
  "customer.noCustomers": "",
  "customer.saveSuccess": "",
  "customer.saveError": "",
  "customer.bulkDelete": "",
  address: "",
  "address.errorName": "",
  "address.loadError": "",
  "address.search": "",
  "address.search.all": "",
  "address.search.pickup": "",
  "address.search.delivery": "",
  "address.searchInfo": "",
  "address.searchError": "",
  "address.name": "",
  "address.emptyName": "",
  "address.subname": "",
  "address.subnameAlter": "",
  "address.street": "",
  "address.emptyStreet": "",
  "address.streetNumber": "",
  "address.emptyStreetNumber": "",
  "address.localDestination": "",
  "address.localDestinationInfo": "",
  "address.city": "",
  "address.emptyCity": "",
  "address.zipCode": "",
  "address.emptyZipCode": "",
  "address.country": "",
  "address.emptyCountry": "",
  "address.contactPerson": "",
  "address.emptyContactPerson": "",
  "address.vat": "",
  "address.emptyVat": "",
  "address.contactPhone": "",
  "address.emptyContactPhone": "",
  "address.contactEmail": "",
  "address.contactEmail.info": "",
  "address.insertionDate": "",
  "address.changeDate": "",
  "address.emptyPreselection": "",
  "address.saveAsCustomer": "",
  "address.validation.zipCode.five": "",
  "address.validation.zipCode.fiveCountry": "",
  "address.validation.zipCode.four": "",
  "address.validation.zipCode.fourCountry": "",
  "address.validation.zipCode.poland": "",
  "address.validation.zipCode.gbAndDe": "",
  "address.validation.zipCode.others": "",
  "address.validation.phone.eight": "",
  "address.validation.phone.nineTen": "",
  "address.validation.phone.nine": "",
  "address.validation.phone.ten": "",
  "address.validation.phone.eleven": "",
  "address.validation.phone.tenMore": "",
  "address.validation.phone.others": "",
  "address.import.dataFormat": "",
  "address.import.info": "",
  "address.import.name": "",
  "address.import.subname": "",
  "address.import.street": "",
  "address.import.streetNumber": "",
  "address.import.localDestination": "",
  "address.import.city": "",
  "address.import.zipCode": "",
  "address.import.country": "",
  "address.import.contactPerson": "",
  "address.import.contactPhone": "",
  "address.import.contactEmail": "",
  "address.self.pickup": "",
  "address.self.delivery": "",
  "address.self.type": "{type}",
  "address.self.depot": "",
  "address.self.emptyDepot": "{type}",
  "address.self.error": "",
  calculator: "",
  "calculator.warning": "",
  "calculator.noProducts": "",
  "calculator.info": "",
  "calculator.priceWithoutVat": "{currency}",
  "calculator.error": "",
  "calculator.checkValues": "",
  "calculator.priceItems": "",
  "calculator.order": "",
  "calculator.emptyValues": "",
  "calculator.address.warning": "",
  "calculator.pickupZip": "",
  "calculator.emptyPickupZip": "",
  "calculator.deliveryZip": "",
  "calculator.emptyDeliveryZip": "",
  "calculator.pickupCountry": "",
  "calculator.emptyPickupCountry": "",
  "calculator.deliveryCountry": "",
  "calculator.emptyDeliveryCountry": "",
  "calculator.addColli": "",
  "calculator.insuranceInfo": "",
  "calculator.height": "",
  "calculator.width": "",
  "calculator.length": "",
  "calculator.weight": "",
  "calculator.price": "",
  "calculator.price.total": "{price} {currency}",
  "calculator.price.unknown": "",
  "calculator.noPrice": "",
  "calculator.price.card": "({price})",
  "calculator.price.B2OC": "",
  "calculator.price.COD": "",
  "calculator.price.FUEL": "",
  "calculator.price.TOLL": "",
  "calculator.price.EB": "",
  "calculator.price.ADR": "ADR",
  "calculator.price.INSR": "",
  "calculator.price.OGB": "",
  "calculator.price.FH": "",
  "calculator.price.CARD": "",
  "calculator.price.B2C": "",
  "calculator.price.PSS": "",
  "calculator.price.EXTRA": "",
  "calculator.price.ES": "",
  "calculator.price.PS": "",
  "calculator.price.DDP": "",
  "calculator.price.CSS": "",
  "calculator.price.DOF": "",
  "calculator.price.TSB": "",
  "calculator.price.GG1": "",
  "calculator.price.GG2": "",
  "calculator.price.GG3": "",
  "calculator.price.GG4": "",
  "calculator.price.WD1": "",
  consignment: "",
  "consignment.edit": "",
  "consignment.detail": "",
  "consignment.new": "",
  "consignment.genitiv": "",
  "consignment.whom": "",
  "consignment.genitivMuiltiple": "",
  "consignment.noConsignments": "",
  "consignment.unsent": "",
  "consignment.saveWithValidation": "{saveWhat}",
  "consignment.errorName": "",
  "consignment.processError": "",
  "consignment.processErrorOnServer": "",
  "consignment.tracking": "",
  "consignment.sent": "",
  "consignment.notSent": "",
  "consignment.dropConsignments": "",
  "consignment.dropConsignments.title": "",
  "consignment.dropConsignments.drop": "",
  "consignment.dropConsignments.noConsignments": "{entity}",
  "consignment.dropConsignments.end": "",
  "consignment.exportConsignments": "",
  "consignment.exportConsignments.title": "",
  "consignment.exportConsignments.noConsignments": "",
  "consignment.sendConsignments": "",
  "consignment.sendConsignmentsTitle": "",
  "consignment.printTitle": "",
  "consignment.noCollis": "",
  "consignment.overWeight": "",
  "consignment.overCalculatedWeight": "",
  "consignment.overVolume": "",
  "consignment.overLoadingMeters": "",
  "consignment.overNotStackable": "",
  "consignment.overCollis": "",
  "consignment.noWrapping": "",
  "consignment.noDescription": "",
  "consignment.badColliDimension": "",
  "consignment.product": "",
  "consignment.unknownProduct": "",
  "consignment.state": "",
  "consignment.code": "",
  "consignment.reference": "",
  "consignment.externalCode": "",
  "consignment.insertionDateTime": "",
  "consignment.customerReference": "",
  "consignment.pickup": "",
  "consignment.delivery": "",
  "consignment.invoice": "",
  "consignment.collis": "",
  "consignment.countOfCollis": "",
  "consignment.type": "",
  "consignment.cashOnDelivery": "",
  "consignment.insurance": "",
  "consignment.insurance.recommendation": "{price}{currency}",
  "consignment.insurance.overPrice": "",
  "consignment.status": "",
  "consignment.lastTrackMessage": "",
  "consignment.sentDateTime": "",
  "consignment.createDate": "",
  "consignment.createdByDhl": "",
  "consignment.changedByDhl": "",
  "consignment.sentByDhl": "",
  "consignment.freapi": "",
  "consignment.variableSymbol": "",
  "consignment.notPrintedLabel": "",
  "consignment.sentDate": "",
  "consignment.sentByUser": "",
  "consignment.codAmount": "",
  "consignment.insurance.withPrice":
    "{price}{currency}{insurancePrice}{insuranceCurrency}",
  "consignment.insurance.noPrice": "",
  "consignment.insurance.noInsurance": "",
  "consignment.colli.barcodeWarning": "",
  "consignment.colli.edit": "",
  "consignment.colli.add": "",
  "consignment.colli.copy": "",
  "consignment.colli.adding": "",
  "consignment.colli.noCollis": "",
  "consignment.colli.biggerThan0": "",
  "consignment.colli.lowerThanMax": "{max}",
  "consignment.colli.invalidValue": "",
  "consignment.colli.count": "",
  "consignment.colli.notStackableCount": "",
  "consignment.colli.volume": "",
  "consignment.colli.emptyCount": "",
  "consignment.colli.wrapping": "",
  "consignment.colli.wrapping.info": "",
  "consignment.colli.wrapping.warn": "",
  "consignment.colli.wrapping.unlimited": "",
  "consignment.colli.wrapping.error": "",
  "consignment.colli.wrapping.errorShort": "",
  "consignment.colli.emptyWrapping": "",
  "consignment.colli.height": "",
  "consignment.colli.emptyHeight": "",
  "consignment.colli.overHeight": "",
  "consignment.colli.width": "",
  "consignment.colli.emptyWidth": "",
  "consignment.colli.overWidth": "",
  "consignment.colli.length": "",
  "consignment.colli.emptyLength": "",
  "consignment.colli.overLength": "",
  "consignment.colli.weight": "",
  "consignment.colli.emptyWeight": "",
  "consignment.colli.overWeight": "{max}",
  "consignment.colli.overCalculatedWeight": "{max}",
  "consignment.colli.weightType1": "",
  "consignment.colli.weightTypeAll": "",
  "consignment.colli.weightTypeAllInfo": "",
  "consignment.colli.overLoadingMeters": "",
  "consignment.colli.description": "",
  "consignment.colli.emptyDescription": "",
  "consignment.colli.manualBarcode": "",
  "consignment.colli.barcode": "",
  "consignment.colli.invalidBarcode": "",
  "consignment.colli.dimensions": "",
  "consignment.colli.barcodeWillBeGenerated": "",
  "consignment.colli.stackable": "",
  "consignment.colli.stackable.yes": "",
  "consignment.colli.stackable.no": "",
  "consignment.colli.stackable.warning": "",
  "consignment.colli.loadingMeters": "",
  "consignment.colli.emptyLoadingMeters": "",
  "consignment.colli.calculatedWeight": "",
  "consignment.template.new": "",
  "consignment.template.edit": "",
  "consignment.template.list": "",
  "consignment.template.name": "",
  "consignment.template.what": "",
  "consignment.template.errorName": "",
  "consignment.template.whom": "",
  "consignment.template.insertionDateTime": "",
  "consignment.template.templateName": "",
  "consignment.template.creator": "",
  "consignment.template.noTemplates": "",
  "consignment.template.createNewFromOld": "",
  "consignment.template.createNew": "",
  "consignment.template.export": "",
  "consignment.template.export.title": "",
  "consignment.template.import": "",
  "consignment.template.import.title": "",
  "consignment.template.import.error": "",
  "consignment.saveAsTemplate": "",
  "consignment.saveAsTemplateInfo": "",
  "consignment.templateName": "",
  "consignment.emptyTemplateName": "",
  "consignment.unknown": "",
  "consignment.loadError": "",
  "consignment.edit.try": "",
  "consignment.send.price": "",
  "consignment.send.question": "",
  "consignment.send.noConsignments": "",
  "consignment.send.error": "",
  "consignment.send.withRef": "{reference}",
  "consignment.send.withoutRef": "",
  "consignment.send.sendSuccess": "",
  "consignment.send.sendError": "",
  "consignment.send.resultTitle": "",
  "consignment.send.countOfValid": "",
  "consignment.send.countOfInvalid": "",
  "consignment.print.noConsignments": "",
  "consignment.print.loadError": "",
  "consignment.print.labelLoadError": "",
  "consignment.print.label": "",
  "consignment.print.zplLabel": "",
  "consignment.print.pdfLabel": "",
  "consignment.print.label3": "",
  "consignment.print.label4": "",
  "consignment.print.consignentList": "",
  "consignment.print.euroLine": "",
  "consignment.print.euroLineCmr": "",
  "consignment.print.euroLineLimitation": "",
  "consignment.print.printConsignentList": "",
  "consignment.print.labelPosition": "",
  "consignment.list.findInUnsend": "",
  "consignment.list.showHistory": "",
  "consignment.list.hideHistory": "",
  "consignment.list.copyTitle": "",
  "consignment.list.valid": "",
  "consignment.list.invalid": "",
  "consignment.list.footer.canBeSend": "",
  "consignment.list.footer.countOfValid": "",
  "consignment.list.footer.cannotBeSend": "",
  "consignment.list.footer.countOfInvalid": "",
  "consignment.pod": "",
  "consignment.pod.empty": "",
  "consignment.pod.show": "",
  "consignment.copy": "",
  "consignment.copy.copy": "",
  "consignment.copy.copying": "",
  "consignment.copy.success": "",
  "consignment.copy.error": "",
  "consignment.return": "",
  "consignment.return.create": "",
  "consignment.return.creating": "",
  "consignment.return.success": "",
  "consignment.return.error": "",
  "consignment.cancel": "",
  "consignment.cancelled": "",
  "consignment.cancel.info": "",
  "consignment.cancel.info.not": "",
  "consignment.cancel.question": "",
  "consignment.cancel.success": "",
  "consignment.cancel.done": "",
  "consignment.state.pickup": "",
  "consignment.state.delivery": "",
  "consignment.state.delivered": "",
  "consignment.state.cancelled": "",
  "consignment.state.cancelled.user": "{first} {last}.",
  "consignment.state.return": "",
  "consignment.import.dataFormat": "",
  "consignment.import.dataFormat.attributes": "",
  "consignment.import.dataFormat.countries": "",
  "consignment.import.dataFormat.collis": "{bold}",
  "consignment.import.dataFormat.flag": "",
  "consignment.import.dataFormat.flagText": "{flag}",
  "consignment.import.dataFormat.products": "",
  "consignment.import.dataFormat.reference": "",
  "consignment.import.dataFormat.pickup.name": "",
  "consignment.import.dataFormat.pickup.subname": "",
  "consignment.import.dataFormat.pickup.street": "",
  "consignment.import.dataFormat.pickup.streetNumber": "",
  "consignment.import.dataFormat.pickup.localDestination": "",
  "consignment.import.dataFormat.pickup.city": "",
  "consignment.import.dataFormat.pickup.zipCode": "",
  "consignment.import.dataFormat.pickup.country": "",
  "consignment.import.dataFormat.pickup.contactPerson": "",
  "consignment.import.dataFormat.pickup.contactPhone": "",
  "consignment.import.dataFormat.pickup.contactEmail": "",
  "consignment.import.dataFormat.pickup.save": "",
  "consignment.import.dataFormat.delivery.name": "",
  "consignment.import.dataFormat.delivery.subname": "",
  "consignment.import.dataFormat.delivery.street": "",
  "consignment.import.dataFormat.delivery.streetNumber": "",
  "consignment.import.dataFormat.delivery.localDestination": "",
  "consignment.import.dataFormat.delivery.city": "",
  "consignment.import.dataFormat.delivery.zipCode": "",
  "consignment.import.dataFormat.delivery.country": "",
  "consignment.import.dataFormat.delivery.contactPerson": "",
  "consignment.import.dataFormat.delivery.contactPhone": "",
  "consignment.import.dataFormat.delivery.contactEmail": "",
  "consignment.import.dataFormat.delivery.save": "",
  "consignment.import.dataFormat.invoice.name": "",
  "consignment.import.dataFormat.invoice.subname": "",
  "consignment.import.dataFormat.invoice.street": "",
  "consignment.import.dataFormat.invoice.streetNumber": "",
  "consignment.import.dataFormat.invoice.localDestination": "",
  "consignment.import.dataFormat.invoice.city": "",
  "consignment.import.dataFormat.invoice.zipCode": "",
  "consignment.import.dataFormat.invoice.country": "",
  "consignment.import.dataFormat.invoice.contactPerson": "",
  "consignment.import.dataFormat.invoice.contactPhone": "",
  "consignment.import.dataFormat.invoice.contactEmail": "",
  "consignment.import.dataFormat.invoice.save": "",
  "consignment.import.dataFormat.colli.count": "",
  "consignment.import.dataFormat.colli.wrapping": "",
  "consignment.import.dataFormat.colli.description": "",
  "consignment.import.dataFormat.colli.barcode": "",
  "consignment.import.dataFormat.colli.height": "",
  "consignment.import.dataFormat.colli.width": "",
  "consignment.import.dataFormat.colli.length": "",
  "consignment.import.dataFormat.colli.weight": "",
  "consignment.import.dataFormat.colli.stackability": "",
  "consignment.import.dataFormat.services.codPrice": "",
  "consignment.import.dataFormat.services.codCurrency": "",
  "consignment.import.dataFormat.services.codVariableSymbol": "",
  "consignment.import.dataFormat.services.documentsBack": "",
  "consignment.import.dataFormat.services.insurance": "",
  "consignment.import.dataFormat.services.peur": "",
  "consignment.import.dataFormat.services.adr": "",
  "consignment.import.dataFormat.services.cash": "",
  "consignment.import.dataFormat.services.pickupFront": "",
  "consignment.import.dataFormat.services.pickupCart": "",
  "consignment.import.dataFormat.services.deliveryFront": "",
  "consignment.import.dataFormat.services.deliveryCart": "",
  "consignment.import.dataFormat.services.lift": "",
  "consignment.import.dataFormat.services.oldBack": "",
  "consignment.import.dataFormat.services.sms": "",
  "consignment.import.dataFormat.services.personalPickup": "",
  "consignment.import.dataFormat.services.personalDelivery": "",
  "consignment.import.dataFormat.services.pod": "",
  "consignment.import.dataFormat.services.iod": "",
  "consignment.import.dataFormat.services.extraInsurance": "",
  "consignment.import.dataFormat.services.documents": "",
  "consignment.import.dataFormat.services.customs": "",
  "consignment.import.dataFormat.services.fdd": "",
  "consignment.import.dataFormat.services.nationalTransportId": "",
  "consignment.import.dataFormat.services.nationalTransportIdFree": "",
  "consignment.import.dataFormat.services.timeSlotBooking": "",
  "consignment.import.dataFormat.services.preAdviseDelivery": "",
  "consignment.import.dataFormat.services.incoterms": "{link}",
  "consignment.import.dataFormat.services.deliveryDate": "",
  "consignment.import.dataFormat.services.price": "",
  "consignment.import.dataFormat.services.priceCurrency": "",
  "consignment.import.dataFormat.services.pickupDate": "",
  "consignment.import.dataFormat.services.pickupDateTo": "",
  "consignment.import.dataFormat.services.deliveryDateTo": "",
  "consignment.import.dataFormat.services.free": "",
  "consignment.import.dataFormat.services.note": "",
  "consignment.import.dataFormat.adr.unClass": "{url}",
  "consignment.import.dataFormat.adr.unCode": "",
  "consignment.import.dataFormat.adr.chemicalName": "",
  "consignment.import.dataFormat.adr.packagingGroup": "",
  "consignment.import.dataFormat.adr.packagingType": "",
  "consignment.import.dataFormat.adr.environmentalHazard": "",
  "consignment.import.dataFormat.adr.packagingDescription": "",
  "consignment.import.dataFormat.adr.quantity": "",
  "consignment.import.dataFormat.adr.quantityType": "",
  "consignment.import.dataFormat.adr.handlingUnitsQuantity": "",
  "consignment.import.dataFormat.adr.grossWeight": "",
  "consignment.services": "",
  "consignment.services.dateCheckError": "",
  "consignment.services.dateCheck.country": "",
  "consignment.services.chooseCurrency": "",
  "consignment.services.palletJack": "",
  "consignment.services.tailLift": "",
  "consignment.services.price": "",
  "consignment.services.emptyPrice": "",
  "consignment.services.emptyInsurance": "{insurancePrice} {insuranceCurrency}",
  "consignment.services.formLoadError": "",
  "consignment.services.pickupDate": "",
  "consignment.services.pickupRange": "",
  "consignment.services.deliveryRange": "",
  "consignment.services.emptyPickupRange": "",
  "consignment.services.pickupHandling": "",
  "consignment.services.deliveryHandling": "",
  "consignment.services.notes": "",
  "consignment.services.incoterms": "",
  "consignment.services.emptyIncoterms": "",
  "consignment.services.incotermsError": "",
  "consignment.services.deliveryDate": "",
  "consignment.services.fdd": "",
  "consignment.services.pod": "",
  "consignment.services.iod": "",
  "consignment.services.extraInsurance": "",
  "consignment.services.customsClearance": "",
  "consignment.services.deliveryAgainstDocuments": "",
  "consignment.services.documentBack": "",
  "consignment.services.sms": "",
  "consignment.services.peur": "",
  "consignment.services.peur.info": "",
  "consignment.services.peurCount": "",
  "consignment.services.emptyPeurCount": "",
  "consignment.services.peurMinCount": "",
  "consignment.services.cashTransportPay": "",
  "consignment.services.payer": "",
  "consignment.services.emptyPayer": "",
  "consignment.services.consignor": "",
  "consignment.services.consignee": "",
  "consignment.services.otherAddress": "",
  "consignment.services.transportOldAppliance": "",
  "consignment.services.carryToFloor": "",
  "consignment.services.carryToFloorInfo": "",
  "consignment.services.ekaer": "",
  "consignment.services.ekaer.empty": "",
  "consignment.services.ekaerFree": "",
  "consignment.services.sent": "",
  "consignment.services.sent.empty": "",
  "consignment.services.sentFree": "",
  "consignment.services.uit": "",
  "consignment.services.uit.empty": "",
  "consignment.services.uitFree": "",
  "consignment.services.timeSlotBooking": "",
  "consignment.services.preAdviseDelivery": "",
  "consignment.services.emptyCodAmount": "",
  "consignment.services.emptyCodCurrencies": "",
  "consignment.services.variableSymbol": "",
  "consignment.services.emptyVariableSymbol": "",
  "consignment.services.payByCreditCard": "",
  "consignment.services.adr": "",
  "consignment.services.adrInfo": "",
  "consignment.services.emptyAdrInfo": "",
  "consignment.services.adr.info": "",
  "consignment.services.adr.unClass": "",
  "consignment.services.adr.emptyUnClass": "",
  "consignment.services.adr.unClassError": "",
  "consignment.services.adr.unCode": "",
  "consignment.services.adr.emptyUnCode": "",
  "consignment.services.adr.chemicalName": "",
  "consignment.services.adr.emptyChemicalName": "",
  "consignment.services.adr.packagingGroup": "",
  "consignment.services.adr.emptyPackagingGroup": "",
  "consignment.services.adr.packagingGroupError": "",
  "consignment.services.adr.packagingType": "",
  "consignment.services.adr.emptyPackagingType": "",
  "consignment.services.adr.packagingTypeError": "",
  "consignment.services.adr.packagingDescription": "",
  "consignment.services.adr.emptyPackagingDescription": "",
  "consignment.services.adr.quantity": "",
  "consignment.services.adr.quantity.extended": "",
  "consignment.services.adr.quantity.over": "",
  "consignment.services.adr.quantity.over.grossWeight": "",
  "consignment.services.adr.emptyQuantity": "",
  "consignment.services.adr.handlingUnitsQuantity": "",
  "consignment.services.adr.handlingUnitsQuantity.over": "",
  "consignment.services.adr.emptyHandlingUnitsQuantity": "",
  "consignment.services.adr.grossWeight": "",
  "consignment.services.adr.grossWeight.over": "",
  "consignment.services.adr.emptyGrossWeight": "",
  "consignment.services.adr.grossWeight.summary": "",
  "consignment.services.adr.environmentalHazard": "",
  "consignment.services.adr.environmentalHazard.empty": "",
  "consignment.services.adr.quantityType": "",
  "consignment.services.adr.limitedQuantity": "",
  "consignment.services.adr.exemptedQuantity": "",
  "consignment.services.adr.emptyPackage": "",
  "consignment.services.adr.fullAdrQuantity": "",
  "consignment.services.adr.underLimitQuantity": "",
  "consignment.services.adr.add": "",
  "consignment.services.adr.drop": "",
  "consignment.product.loadError": "",
  "consignment.product.chooseProduct": "",
  "consignment.product.chosenProduct": "",
  "consignment.product.choose": "",
  "consignment.product.cannotLoad": "",
  "invoice.list": "",
  "invoice.export": "",
  "invoice.what": "",
  "invoice.errorName": "",
  "invoice.code": "",
  "invoice.codeFull": "",
  "invoice.noInvoices": "",
  "invoice.state": "",
  "invoice.paid": "",
  "invoice.canceled": "",
  "invoice.notPaid": "",
  "invoice.creditNote": "",
  "invoice.notPaidAndAfterDueDate": "",
  "invoice.invoiceType": "",
  "invoice.issueDate": "",
  "invoice.taxableDate": "",
  "invoice.dueDate": "",
  "invoice.payDate": "",
  "invoice.daysAfterDueDate": "",
  "invoice.amount": "",
  "invoice.currency": "",
  "invoice.afterPayDate": "",
  "invoice.onlyNotPaid": "",
  "prints.zebraList": "",
  "prints.labelList": "",
  "prints.invoiceList": "",
  "prints.invoiceList.noInvoices": "",
  "prints.addressList": "",
  "prints.addressList.noAddresses": "",
  "prints.pages": "{pageNumber}{totalPages}",
  "prints.printedOn": "{dt}",
  import: "{what}",
  "import.format": "{type}",
  "import.message": "",
  "import.download": "",
  "import.dataFormat": "",
  "import.cancelLoading": "",
  "import.fileTypes": "",
  "import.result": "",
  "import.uploadAborted": "",
  "import.supportedFormats": "",
  "import.templateResult": "{templateName} ({row})",
  "import.referenceResult": "{customerReference} ({row})",
  "import.customerResult": "{name} ({row})",
  "import.entityResult": "{entity}{row}",
  "import.success": "",
  "import.error": "{what}",
  "import.fileType": "",
  "import.containsHeader": "",
  "import.workbookNUmber": "",
  "import.emptyWorkbookNUmber": "",
  "import.filePassword": "",
  "import.colliDelimiter": "",
  "import.emptyColliDelimiter": "",
  "import.coding": "",
  "import.emptyCoding": "",
  "import.firstDelimiter": "",
  "import.delimiter": "",
  "import.emptyDelimiter": "",
  "import.uploadSuccess": "{name}",
  "import.uploadError": "{message}",
  "import.uploadErrorInfo": "",
  "import.uploadFailure": "{name}",
  "import.clickOrDrag": "",
  "export.pdf": "",
  "export.xlsx": "",
  "export.error": "",
  "export.noEntitiesAll": "{entity}",
  "export.noEntities": "{entity}",
  tracking: "",
  "tracking.error": "",
  "tracking.emptyCode": "",
  "tracking.placeholder": "",
  "tracking.findNew": "",
  "tracking.serverError": "",
  "tracking.yourConsignment": "",
  "tracking.place": "",
  "tracking.dateTime": "",
  "tracking.message": "",
  "tracking.transportDetail": "",
  "tracking.actualState": "",
  "tracking.actualState.message": "",
  "tracking.actualState.dateTime": "",
  "tracking.information": "",
  "tracking.consignment.code": "",
  "tracking.consignment.orderCode": "{orderCode}",
  "tracking.consignment.sender": "",
  "tracking.consignment.customerReference": "",
  "tracking.consignment.countOfCollis": "",
  "tracking.consignment.weight": "",
  "tracking.consignment.cashOnDelivery": "",
  notification: "",
  "notification.list": "",
  "notification.new": "",
  "notification.edit": "",
  "notification.createNew": "",
  "notification.unknown": "",
  "notification.name.def": "",
  "notification.name": "",
  "notification.name.empty": "",
  "notification.title.cz": "",
  "notification.title.cz.empty": "",
  "notification.title.en": "",
  "notification.title.en.empty": "",
  "notification.title.pl": "",
  "notification.title.pl.empty": "",
  "notification.message.cz": "",
  "notification.message.en": "",
  "notification.message.pl": "",
  "notification.message.empty": "",
  "notification.insertionDateTime": "",
  "notification.errorName": "",
  "notification.notificationName": "",
  "notification.creator": "",
  "notification.what": "",
  "notification.noNotifications": "",
  "notification.displayToUsers.filter": "",
  "notification.displayToUsers": "",
  "notification.displayToUsers.yes": "",
  "notification.displayToUsers.no": "",
  "notification.validTo": "",
  "notification.validTo.info": "",
  "notification.validTo.to": "{date}",
  "notification.changeDateTime": "",
  "notification.changer": "",
  "notification.save.success": "",
  "notification.save.error": "",
  "notification.confirm": "",
  "notification.later": "",
  "notification.read": "",
  "contracts.header": "",
  "contracts.error": "",
  "contracts.terms": "",
  "contracts.terms.agree": "{date}",
  "contracts.terms.here": "",
  "contracts.terms.check": "",
  "contracts.terms.check.contract": "",
  "contracts.terms.check.no": "",
  "contracts.terms.check.agree": "",
  "contracts.terms.check.agree.no": "",
  "contracts.terms.check.question": "",
  "contracts.terms.check.questions.title": "",
  "contracts.terms.check.question.success": "",
  "contracts.terms.check.question.error": "",
  "contracts.contract": "",
  "contracts.contract.pricelist.ecd": "",
  "contracts.contract.pricelist.eci": "",
  "contracts.contract.no": "",
  "oneTimeLogin.list": "",
  "oneTimeLogin.errorName": "",
  "oneTimeLogin.new": "",
  "oneTimeLogin.new.long": "",
  "oneTimeLogin.new.title": "",
  "oneTimeLogin.save": "",
  "oneTimeLogin.lastLogin": "",
  "oneTimeLogin.used": "",
  "oneTimeLogin.validity": "",
  "oneTimeLogin.invalid": "{date}",
  "oneTimeLogin.deleted": "{date}",
  "oneTimeLogin.valid": "{date}",
  "oneTimeLogin.inserter": "",
  "oneTimeLogin.changer": "",
  "oneTimeLogin.deleter": "",
  "oneTimeLogin.drop": "",
  "oneTimeLogin.drop.success": "",
  "oneTimeLogin.drop.dropped": "",
  "oneTimeLogin.drop.error": "",
  "oneTimeLogin.resend.success": "",
  "oneTimeLogin.resend.limit": "",
  "oneTimeLogin.resend.unknown": "",
  "oneTimeLogin.resend.error": "",
  "oneTimeLogin.whom": "",
  "oneTimeLogin.noUsers": "",
  "oneTimeLogin.phone": "",
  "oneTimeLogin.phone.empty": "",
  "oneTimeLogin.code": "",
  "document.new": "",
  "document.edit": "",
  "document.load.error": "",
  "document.current": "",
  "document.clients": "",
  "document.clients.info": "",
  "document.upload.button": "",
  "document.upload.success": "{name}",
  "document.upload.response": "{message}.",
  "document.upload.error": "{name}",
  "document.upload.exceed": "{max}",
  "document.onlyTxt": "",
  "document.file": "",
  "document.url": "",
  "document.name": "",
  "document.name.client": "",
  "document.desc": "",
  "document.type": "",
  "document.type.miss": "",
  "document.type.error": "",
  "document.TermsAndConditions": "",
  "document.PriceList": "",
  "document.Others": "",
  "document.validFrom": "",
  "document.validTo": "",
  "document.url.validation": "",
  "document.autoResult": "",
  "document.autoResult.confirm": "",
  "document.autoResult.reject": "",
  "document.blockOnReject": "",
  "document.email": "",
  "document.email.info": "",
  "document.email.confirm": "",
  "document.email.reject": "",
  "document.create.success": "",
  "document.create.badData": "",
  "document.create.noClients": "",
  "document.create.notFoundClients": "",
  "document.create.fileError": "",
  "document.create.error": "",
  "document.list": "",
  "document.processed": "",
  "document.notProcessed": "",
  "document.what": "",
  "document.notProcessed.noData": "",
  "document.processed.noData": "",
  "document.blockOnReject.true": "",
  "document.blockOnReject.false": "",
  "document.inserter": "",
  "document.result": "",
  "document.confirmed": "",
  "document.rejected": "",
  "document.confirm": "",
  "document.reject": "",
  "document.resolve.success": "",
  "document.resolve.error": "",
  "document.resolve.logout": "",
  "document.download": "",
  "document.link.title": "",
  "document.confirm.role": "",
  "document.validTo.approve": "",
  "document.validTo.reject": "",
  "document.read": "",
  "document.read.info": "{second}",
  "document.read.info.user": "",
  "document.read.info.admin": "",
  "document.clients.notFound": "{clients}",
  "document.drop": "",
  "document.drop.success": "",
  "document.drop.error": "",
};
